<template>
    <div class="career-contact">
        <z-caption tag="h2" size="lt" :style="{ marginBottom: '8px !important' }">Контакты</z-caption>
        <div class="text-size-xl u-bottom-margin--2xl">Программы для школьников</div>
        <div class="career-contact__wrapper">
            <z-contact-card
                v-for="person in detail.item.contactsPerson"
                :key="person.id"
                horizontal
                show-icons
                size="l"
                :showCaptions="false"
                :data="{
                    title: person.name,
                    previewPicture: person.avatar?.link,
                    previewText: person.position?.value,
                    phones: [ formatPhone(person.phone?.value) ],
                    emails: [
                        {
                            value: person.email?.value,
                            text: person.email?.value
                        }
                    ],
                }"
            ></z-contact-card>
            <div class="career-contact__socials" >
                <p class="text-size-xl u-semi-bold u-bottom-margin--2xs">Следите за&nbsp;новостями</p>
                <div class="u-flex u-gap--s u-flex-wrap">
                    <z-link
                        v-bind:href="'https://vk.com/' + (detail.item.name == 'Академия ИНК' ? 'academia_ink':'irkutskoilcompany')"
                        target="_blank"
                        class="career-contact__social">
                        <z-icon
                            width="32"
                            height="32"
                            class="career-contact__social--vk"
                            name="social/vk"/>
                    </z-link>
                    <z-link v-if="detail.item.name != 'Академия ИНК'"
                        href="https://dzen.ru/irkutskoilcompany"
                        target="_blank"
                        class="career-contact__social">
                        <z-icon
                            width="32"
                            height="32"
                            class="career-contact__social--dzen"
                            name="social/yandex_zen"/>
                    </z-link>
                    <z-link
                        v-bind:href="'https://t.me/' + (detail.item.name == 'Академия ИНК' ? 'AcademyINK':'irkutskoilcompany')"
                        target="_blank"
                        class="career-contact__social">
                        <z-icon
                            width="32"
                            height="32"
                            class="career-contact__social--tg"
                            name="social/telegram"/>
                    </z-link>
                    <z-link
                        v-bind:href="'https://max.ru/irkutskoilcompany'"
                        target="_blank"
                        class="career-contact__social">
                        <z-icon
                            width="32"
                            height="32"
                            class="career-contact__social--max"
                            name="social/max"/>
                    </z-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useGetter } from '@/composable/useGetter'

const { app } = useGetter(['app'])
const detail = app.value.components['programs-detail']

const formatPhone = (phoneValue) => {
    if (!phoneValue) return { value: '', text: '' };

    let digits = phoneValue.toString().replace(/\D/g, '');

    if (digits.length === 11 && (digits[0] === '7' || digits[0] === '8')) {
        digits = digits.substring(1);
    }

    if (digits.length !== 10) return { value: phoneValue, text: phoneValue };

    return {
        value: `+7${digits}`,
        text: `+7 (${digits.slice(0, 3)}) ${digits.slice(3, 6)} ${digits.slice(6)}`
    };
};
</script>

<style lang="scss">
.career-contact {
    &__wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;

        @include breakpoint (tablet) {
            align-items: flex-start;
        }

        @include breakpoint(mobile) {
            flex-direction: column;
            align-items: start;
            gap: 30px;
        }
    }

    &__socials {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    .z-contact-card {
        // width: 60%;
        // justify-content: space-between;

        flex-grow: 1;
        justify-content: space-between;

        flex-direction: row;
        margin-right: var(--spacer-s);

        @include breakpoint (v-tablet) {
            flex-direction: column;
        }
    }

    .z-contact-card,
    .z-contact-person {
        align-items: center;

        @include breakpoint(tablet) {
            align-items: flex-start;
        }
    }

    &__social {
        border-radius: 50px;
        background: #EAF6F4;
        padding: 20px;

        @include breakpoint(v-tablet) {
            padding: 12px;
        }

        path {
            transition: fill 0.25s ease-out, stroke 0.25s ease-out;
        }

        &--vk,
        &--tg {
            path {
                fill: var(--color-primary);
                stroke: var(--color-primary);
            }

            &:hover {
                path {
                    fill: var(--color-link-light-hover);
                    stroke: var(--color-link-light-hover);
                }
            }

            &:active {
                path {
                    fill: var(--color-link-light-active);
                    stroke: var(--color-link-light-active);
                }
            }
        }

        &--dzen {
            path {
                &:first-child {
                    fill: var(--color-primary);
                }

                &:nth-child(2) {
                    fill: transparent;
                }
            }

            &:hover {
                path {
                    &:first-child {
                        fill: var(--color-link-light-hover);
                    }

                    &:nth-child(2) {
                        fill: transparent;
                    }
                }
            }

            &:active {
                path {
                    &:first-child {
                        fill: var(--color-link-light-active);
                    }

                    &:nth-child(2) {
                        fill: transparent;
                    }
                }
            }
        }
    }

    .z-contact-card__item:not(.z-phone) .z-contact-card__title .z-icon path {
        fill:  var(--color-table-text-totall);
    }

    .z-contact-card__item.z-phone .z-contact-card__title .z-icon path {
        stroke:  var(--color-table-text-totall);
    }

    .z-contact-card__link .z-link__text{
        color: var(--color-table-text-totall);
    }

    .z-contact-person__image {
        border-radius: 50%;
    }
}
</style>
